export default __webpack_public_path__ + "static/media/2459.5b52462e.png";